export default {
  methods: {
    changeNumericValue(val) {
      if(val !== null) {
        if(val.key.indexOf('.') !== -1 || val.key.indexOf(',') !== -1) {
          val.preventDefault();
        }
      }
    },
  }
};
